import { createMuiTheme, makeStyles, createStyles  } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';




const theme = createMuiTheme({
    breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 1100,
          xl: 1500
        }
      },
      typography: {
        useNextVariants: true,
        // subh61: {
        //     fontSize: 50,
        // },
        // colorTextSecondary: {

        // },
        // headline: {

        // },
        subtitle1:{
            color: grey[900],
        },
        //Table header
        subtitle2:{
            whiteSpace: 'nowrap',
            color: grey[900],
        },
        h6: {
            fontSize: "1.1rem",
            fontWeight: "400",
        },
        h5: {
            fontSize: '1rem',
            color: grey[900],        
        },
        body1: {
            color: grey[800],
        },
        //Table content
        body2: {
            fontSize: '0.7rem',
            color: grey[800],
        },

      },
});
export const grid_spacing = 1
export const styles = theme => ({
    // styles-card
    font_family: {
        fontFamily: 'Open Sans',
    },
    tooltipcustomWidth: {
      maxWidth: 200,
      fontSize: "1rem"
    },
    card_full: {
        minHeight: 150,
        height: '90vh',
        overflowY: "auto"
    },
    card_vendor_info: {
        height: '49vh',
        overflowY: "auto"
    },
    cardL0: {
        minHeight: 150,
        height: '80vh',
        overflowY: "auto"
    },
    dashboard_cardL1: {
        minHeight: 150,
        height: "15vh",
    },
    cardL1: {
        minHeight: 150,
        height: "45vh",
        overflowY: "auto"
    },
    dashboard_cardL2: {
        minHeight: 200,
        overflowY: "auto",
        height: "320px",
    },
    cardL2: {
        minHeight: 200,
        height: "45vh",
        overflowY: "auto",
        // overflowX: "auto",
    },
    cardL3: {
        minHeight: 200,
        height: "30vh",
        overflowY: "auto"
    },
    cardL4: {
        minHeight: 100,
        height: "15vh",
    },
    indexing_cardL4_clickable: {
        height: "180px",
        width: "180px",
        margin: "10px 10px 10px 10px",
        backgroundColor: "rgb(0, 145, 218)",
        color: "rgb(255, 255, 255)"
    },

    indexing_cardL4_non_clickable: {
        height: "180px",
        width: "180px",
        margin: "10px 10px 10px 10px",
        backgroundColor: "rgb(160, 160, 160)",
        color: "rgb(255, 255, 255)"
    },

    indexing_card_content: {
        margin: 0,
        padding: 0, 
        height: "100%", 
        width: "100%"
    },

    card_fit_content: {
        minHeight: 200,
        height: 'fit-content',
        overflowY: "auto"
    },
    cardAction: {
        width: "100%",
        height: "100%"
    },
    cardHeader: {
        marginTop: "20px",
        padding: "4px",
    },
    cardContentTxt: {
        textAlign:"left",
        paddingLeft: "16px",
    },
    // styles-card-content
    content: {
        //ventically center the div
        padding: '16px 16px 24px 16px',
        paddingBottom: '0px !important',
        height: '100%'
    },

    // chart needs a different style because the header is separated from chart component,
    // and thus the header text occupy some space and the height for chart has to be less
    // than 100%
    content_chart: {
        //ventically center the div
        padding: '0px 0px 0px 0px',
        paddingBottom: '0px !important',
        height: '74%'
    },

    transaction: {
        backgroudColor: "rgba(188,32,75,1)",
        color: "snow"
    },

    media: {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: 'cover'
    },
    horizontalbarstyle: {
        padding : 0
    },



    // used in KRI Dashboard
    content_compact: {
        height: '60%',
        width: '80%',
        margin: 'auto'
    },
    content_table: {
        //ventically center the div
        padding : '30px 20px 0px 20px',
        position: "relative",
        overflowY: "auto",
    },





    // styles-table
    table_cell: {
        padding : '0px 4px 0px 4px',
        fontSize: '0.8125rem'
    },
    table_cell_nowrap: {
        whiteSpace: 'nowrap',
        padding : '0px 4px 0px 4px',
        fontSize: '0.8125rem'
    },


    table_header_compact: {
        padding : '0px 4px 0px 4px',
        height: '24px',
        backgroundColor: '#E3EDF6',
    },
    table_header_short: {
        padding : '0px 4px 0px 4px',
        height: '32px',
        backgroundColor: '#E3EDF6',
    },
    table_header_default: {
        padding : '0px 4px 0px 4px',
        height: '48px',
        backgroundColor: '#E3EDF6',
    },
    table_header_tall: {
        padding : '0px 4px 0px 4px',
        height: '64px',
        backgroundColor: '#E3EDF6',
    },
    table_header_text: {
        height: '18px',
        color: '#171717',
        fontFamily: 'Open Sans',
        fontSize: '14px',
        fontWeight: '600',
        letterSpacing: '0.16px',
        lineHeight: '18px',
        whiteSpace:'nowrap',
        padding: '0'
    },

    table_cell_compact: {
        padding : '0px 4px 0px 4px',
        height: '24px',
        backgroundColor: '#F4F6F8',
    },
    table_cell_short: {
        padding : '0px 4px 0px 4px',
        height: '32px',
        backgroundColor: '#F4F6F8',
    },
    table_cell_default: {
        padding : '0px 4px 0px 4px',
        height: '48px',
        backgroundColor: '#F4F6F8',
    },
    table_cell_tall: {
        padding : '0px 4px 0px 4px',
        height: '64px',
        backgroundColor: '#F4F6F8',
    },
    table_cell_text: {
        height: '18px',
        color: '#565656',
        fontFamily: 'Open Sans',
        fontSize: '14px',
        letterSpacing: '0.16px',
        lineHeight: '18px',
        padding: '0'
    },




    table_header: {
        padding : '0px 4px 0px 4px',
        fontSize: '0.8125rem'
    },
    table_rows: {
        height: '40px'
    },

    // styles-others
    details: {
        padding : 0,
        height:"100%"
    },
    chart: {
        height: "35vh",
    },


    // style-font
    title: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        padding: '13px',
        textAlign: 'center'
    },

    subtitle: {
        fontSize: '1.5rem',
        minHeight: '18px',
        textAlign: 'center'
    },







    root: {
        width: '100%'
    },
    table: {
        padding:'15px 5px 0px 15px',
    },
    tableWrapper: {
        overflowX: 'auto',
        overflowY: 'auto',
        height: '100%'
    },
    contentWrapper: {
        height: "100%",
        //overflowY: "scroll"
    },
    margin: {
        height: 56,
        marginLeft: theme.spacing.unit,
        padding: 8,
    },

    grid:{
        borderRight: "2px solid grey",
        height: '100%'
    },

    padding: {
        padding: `0 ${theme.spacing.unit * 2}px`
    },
    card: {
        width: "100%",
        height: '68vh'
    },
    card_row_expand: {
        marginLeft:"40%"
    },
    header: {
        textAlign: "center"
    },

    actions: {
        display: 'flex',
        height: 56
    },

    actionContent: {
        textAlign: "center",
        height: '50vh',
        overflow: "auto"
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginRight: -8
        }
    },
    expandOpen: {
        transform: 'rotate(180deg)'
    },
    avatar: {
        backgroundColor: 'rgb(188, 32, 75)'
    },

    inputForm:{
        paddingLeft: '30px',
        //paddingTop: '30px',
        paddingRight: '30px',
        textAlign:"left",
        height: '75%',
        overflowY: 'scroll'
    },
    FormNavi:{
        paddingLeft: '30px',
        //paddingTop: '30px',
        paddingRight: '30px',
        height: "30%",
        textAlign:"left",
    },
    FormHeader:{
        paddingTop: '30px',
    },

    FormDivider:{
        margin: "10px",
        marginLeft:0,
        marginRight:0,
        borderBottom: "1px solid grey"
    },

    divider_within_form:{
        margin: "10px",
        marginLeft:0,
        marginRight:0,
        borderBottom: "1px solid rgb(255,255,255,0.1)"
    },

    FormDirectoryBotton:{
        width: "30%",
        margin:"5px",
        textAlign: "left",
        display:"inline",
        border:"1px solid grey"
    },

    FormTextField: {
        marginBottom: "20px"
    },

    FromSubHeader: {
        paddingTop: '10px',
        display: 'inline-block',
        minWidth: '160px'
    },

    TextFieldFont: {
        style: { fontSize: 15 }
    },

    TextFieldinputShort: {
        style: { textAlign: "center" }
    },
    TextFieldinputLong: {
        style: { overflow: "hidden" }
    },

    button_table_add_neww: {
        display: 'block', 
        textAlign:'center',
        paddingTop: '10px'
    },

    button: {
        margin: '10px'
    },
    // styles-color
    white: {
        color: 'rgb(255, 255, 255)'
    },
    blue: {
        color: 'rgb(0, 51, 141)'
    },
    medium_blue: {
        color: 'rgb(0, 94, 184)'
    },
    light_blue: {
        color: 'rgb(0, 145, 218)'
    },
    violet: {
        color: 'rgb(72, 54, 152)'
    },
    purple: {
        color: 'rgb(71, 10, 104)'
    },
    light_purple: {
        color: 'rgb(109, 32, 119)'
    },
    green_blue: {
        color: 'rgb(0, 163, 161)'
    },
    dark_green: {
        color: 'rgb(0, 154, 68)'
    },
    light_green: {
        color: 'rgb(67, 176, 42)'
    },
    yellow: {
        color: 'rgb(234, 170, 0)'
    },
    orange: {
        color: 'rgb(246, 141, 46)'
    },
    red: {
        color: 'rgb(188, 32, 75)'
    },
    pink: {
        color: 'rgb(199, 0, 126)'
    },
    dark_brown: {
        color: 'rgb(117, 63, 25)'
    },
    light_brown: {
        color: 'rgb(155, 100, 46)'
    },
    olive: {
        color: 'rgb(157, 147, 117)'
    },
    belge: {
        color: 'rgb(227, 188, 159)'
    },
    light_pink: {
        color: 'rgb(227, 104, 119)'
    },
    bright_yellow: {
        color: 'rgb(255, 227, 10)'
    },
    grey: {
        color: 'rgb(157, 147, 117)'
    },
    green: {
        color: 'rgb(67, 176, 42)'
    },
    amber: {
        color: 'rgb(246, 141, 46)'
    },
    black: {
        color: 'rgb(0, 0, 0)'
    }
})


// WEBPACK FOOTER //
// ./src/components/CSS/Styles.js